import React, { useEffect } from 'react';

const Modal = ({ isOpen, onClose, children }) => {

    useEffect(() => { }, []);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal">
                <button className="close-button" onClick={onClose}><i class="fa fa-close"></i></button>
                {children}
            </div>
        </div>
    );
};

export default Modal;